import styled from 'styled-components';
import { colors } from 'styles/colors';
import { primaryScrollbar } from '~/styles/scrollbar';

export const Table = styled.table`
  white-space: wrap;
  border-collapse: collapse;
  background-color: ${colors.bg['white-0']};

  &, th, td {
    border: 1px solid ${colors.stroke['soft-200']};
    text-align: left;
    font-size: 12px;
    padding: 4px;
    padding-bottom: 0;
  }

  th, td {
    min-width: 100px;
    max-width: 268px;
  }

  td {
    text-align: right;
  }

  td:nth-child(1) {
    min-width: 268px;
    text-align: left;
  }

  td:nth-child(2), td:nth-child(3) {
    text-align: center;
  }
`;

export const TableColumn = styled.td<{
  error?: boolean
}>`
  text-align: right;
  background-color: ${({ error }) => (error ? colors.bg['danger-light'] : colors.bg['white-0'])}
`;

export const ValidationContainer = styled.div`
  overflow: auto;
  padding-bottom: 16px;
  width: 100%;
  max-height: 272px;
  ${primaryScrollbar}
`;
